import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  vendorDetail: null,
  vendorLoading: false,
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    _setVendorDetail: (state, action) => {
      state.vendorDetail = action.payload;
    },
    _setVendorLoading: (state, action) => {
      state.vendorLoading = action.payload;
    },
  },
});

export const { _setVendorDetail, _setVendorLoading } = vendorSlice.actions;

export default vendorSlice.reducer;
